"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-9fb96132"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "text-left flex-column generator-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("h5", null, "AIでシフトを作成してみましょう。", -1 /* HOISTED */));
const _hoisted_3 = { class: "font-sm" };
const _hoisted_4 = { class: "align-center flex-gap mt-1" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", null, "Provider:", -1 /* HOISTED */));
const _hoisted_6 = { class: "d-flex flex-wrap flex-gap font-sm" };
const _hoisted_7 = ["value"];
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_9 = { class: "flex-column flex-gap" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("h5", { class: "m-0" }, "シフトの微調整", -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "シフトをより最適化するために、下のテキストボックスに追加条件を入力できます。", -1 /* HOISTED */));
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = { class: "oplus-form-checkbox form-label" };
const _hoisted_14 = {
    key: 0,
    class: "accordion"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("input", {
    type: "checkbox",
    id: "accordion-history",
    name: "accordion-checkbox",
    hidden: ""
}, null, -1 /* HOISTED */));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    class: "accordion-header p-0",
    for: "accordion-history"
}, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" 履歴 ")
], -1 /* HOISTED */));
const _hoisted_17 = { class: "accordion-body mb-0" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "※AIが作成した内容は、自動処理の性質上、誤った日付や意図しない割り当てが含まれる可能性があります。内容を確認のうえ、必要に応じて修正してください。", -1 /* HOISTED */));
const vue_3 = require("vue");
const autoAI_1 = require("../model/autoAI");
const provider_1 = require("../../../../provider/provider");
const periodTypes_1 = __importDefault(require("../../../../table/v1/periodTypes"));
const AutoAIPromptHistory_vue_1 = __importDefault(require("./AutoAIPromptHistory.vue"));
const autoAIStorage_1 = require("../../../../storage/autoAIStorage");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIShiftGenerator',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.autoAIViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const instructions = (0, vue_3.computed)({
            get: () => viewModel?.value.instructions || '',
            set: (text) => presenter?.setIntructions(text),
        });
        const sendSkills = (0, vue_3.computed)({
            get: () => viewModel?.value.sendSkills || false,
            set: (value) => presenter?.setSendSkills(value),
        });
        const provider = (0, vue_3.computed)({
            get: () => viewModel?.value.provider || autoAI_1.defaultAutoAIProvider,
            set: (value) => presenter?.setProvider(value),
        });
        const isDWS = (0, vue_3.computed)(() => {
            return viewModel?.value.timePeriodType === periodTypes_1.default.DAY;
        });
        const roleLabel = (0, vue_3.computed)(() => {
            return isDWS.value ? '業務セクション' : '業務';
        });
        const description = (0, vue_3.computed)(() => {
            return isDWS.value
                ? "業務管理ページで設定した業務セクションに基づき、AIが日ごとの作業スケジュールを作成します。配置スタッフ、タイムプラン、カレンダーが考慮されます。"
                : "業務管理ページで選択した業務と設定に基づいて、AIが月間のシフトを自動作成します。各業務に割り当てるスタッフや1日の必要人数も考慮されます。";
        });
        const promptHistory = (0, vue_3.computed)(() => {
            return viewModel?.value.promptHistory || [];
        });
        const showPromptHistory = (0, vue_3.computed)(() => {
            return promptHistory.value.length > 0;
        });
        async function deletePrompt(prompt) {
            if (!viewModel?.value) {
                return;
            }
            await (0, autoAIStorage_1.deleteAutoAIPrompt)(prompt, viewModel.value.userId, viewModel.value.branchId);
            presenter?.deletePromptHistory(prompt.id);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", null, [
                    _hoisted_2,
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(description.value), 1 /* TEXT */),
                    (0, vue_2.createCommentVNode)(" Provider "),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        _hoisted_5,
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(autoAI_1.autoAIProviderOptions), (option) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                    key: option,
                                    class: "oplus-form-radio"
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((provider).value = $event)),
                                        value: option,
                                        type: "radio"
                                    }, null, 8 /* PROPS */, _hoisted_7), [
                                        [vue_2.vModelRadio, provider.value]
                                    ]),
                                    _hoisted_8,
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(option), 1 /* TEXT */)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                        class: "form-input generator-text",
                        rows: "5",
                        placeholder: `例①）目的と優先順位をわかりやすく記載すると、AIが要望をくみ取りやすくなります！〇〇を△△したい。まずは${roleLabel.value}Aが〇〇で△△してください。次に〇〇を優先してください。

例②）会話をするように指示出しをすることも可能です！Aさんは夜勤少なめにしてあげて。BさんとCさんはスキルがあるから、${roleLabel.value}〇〇ができれば被らないほうがいいです。〇日はイベントだから、必要人数より〇人多く割り振ってほしい！

アルバイトのタグがついたスタッフは公休を〇日以上にする。
新人のタグがついているスタッフは、必ずリーダーのタグがついたスタッフと同じ時間、同じ${roleLabel.value}を割り振る。`,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((instructions).value = $event))
                    }, null, 8 /* PROPS */, _hoisted_12), [
                        [vue_2.vModelText, instructions.value]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", null, [
                    (0, vue_2.createElementVNode)("label", _hoisted_13, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((sendSkills).value = $event)),
                            type: "checkbox"
                        }, null, 512 /* NEED_PATCH */), [
                            [vue_2.vModelCheckbox, sendSkills.value]
                        ]),
                        (0, vue_2.createTextVNode)(" シフト作成時にスキルを考慮する ")
                    ])
                ]),
                (showPromptHistory.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                        _hoisted_15,
                        _hoisted_16,
                        (0, vue_2.createElementVNode)("div", _hoisted_17, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(promptHistory.value, (prompt) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AutoAIPromptHistory_vue_1.default, {
                                    prompt: prompt,
                                    onDeletePrompt: deletePrompt
                                }, null, 8 /* PROPS */, ["prompt"]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                _hoisted_18
            ]));
        };
    }
});
